// 处理请求返回结果（学院接口数据结构）
// 成功：{data: xxx}
// 失败：{error: msg}
export const handleLearningRequest = (result) => {
  if (!result) return { error: 'unknown' };

  if (result.code === 200) {
    return { data: result.data, _updated: result._updated };
  }
  return { error: result.msg };
};


// WEBPACK FOOTER //
// ./src/services/util.js